'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class Lottery {
  createBet(params) {
    return index.adapter.lottery.createBet(params);
  }
  bulkBuying(params) {
    return index.adapter.lottery.bulkBuying(params);
  }
  getOpenDraws(lotteryId, countryCode) {
    const params = {
      countryCode,
      lotteryId
    };
    return index.adapter.lottery.getOpenDraws(params);
  }
  getPreviousDraws(dateFrom, dateTo) {
    const params = {
      dateFrom,
      dateTo
    };
    return index.adapter.lottery.getPreviousDraws(params);
  }
  getProviders() {
    return index.adapter.lottery.getProviders();
  }
  getUserBets(dateFrom, dateTo, betStatus) {
    const params = {
      dateFrom,
      dateTo,
      betStatus
    };
    return index.adapter.lottery.getUserBets(params);
  }
  getUserBetResults(dateFrom, dateTo, betStatus) {
    const params = {
      dateFrom,
      dateTo,
      betStatus
    };
    return index.adapter.lottery.getUserBetResults(params);
  }
  getPayoutTable(drawId) {
    const params = {
      drawId
    };
    return index.adapter.lottery.getPayoutTable(params);
  }
  getWinningNumbersForDraw(drawId) {
    const params = {
      drawId
    };
    return index.adapter.lottery.getWinningNumbersForDraw(params);
  }
  get(lotteryId, demographic) {
    const params = __spreadValues({
      lotteryId
    }, demographic);
    return index.adapter.lottery.get(params);
  }
  getAll(demographic) {
    return index.adapter.lottery.getAll(demographic);
  }
  subscribe(params) {
    return index.adapter.lottery.subscribe(params);
  }
  unsubscribe(params) {
    return index.adapter.lottery.unsubscribe(params);
  }
}
const lottery = new Lottery();

exports.lottery = lottery;
